/**
 * Batch 49 — Shared ABA form design tokens.
 *
 * One source of truth for grid spacing, card padding, control heights, and
 * drawer sizing. Every ABA page reads from here so a change in the spec
 * ripples across the module rather than needing dozens of scattered edits.
 *
 * The values match the spec section 8 (Shared ABA form design tokens).
 */
export const ABA = {
  // Grid + spacing
  gridSpacing: 2,          // 16px between columns (MUI spacing unit = 8px)
  verticalFieldGap: 2.25,  // 18px between vertical fields
  sectionGap: 2.5,         // 20px between section cards

  // Card / drawer geometry
  cardRadius: 12,
  cardPadding: 2.5,        // 20px
  drawerContentPadding: 3, // 24px
  stickyFooterHeight: 72,

  // Control heights (used only where MUI's default size="small" doesn't fit).
  inputHeight: 44,
  multilineMinHeight: 88,

  // Column-span helpers for a 12-column responsive grid. The intent is that
  // callers use `ABA.col.quarter` in xs/sm/lg keys so a single value change
  // updates every field row that shares the pattern.
  // Table config used by every ABA list.
  table: {
    density: "small" as const,
    cellPadding: 1,             // 8px vertical
    headerHeight: 44,
    rowHeight: 52,
    actionColWidth: 128,        // right-anchored, sticky-recommended
    statusColWidth: 140,
    stickyActionColumn: true,
    horizontalScrollContainer: true,
  },

  col: {
    // Four equal columns on desktop → half on tablet → full on mobile.
    quarter: { xs: 12, sm: 6, lg: 3 } as const,
    // Third+two-thirds split (e.g. Next Phase + Criteria).
    thirdEight: { xs: 12, lg: 4 } as const,
    twoThirds: { xs: 12, lg: 8 } as const,
    // Three equal columns for Move Back regression (Threshold / Sessions / Previous).
    third: { xs: 12, sm: 6, lg: 4 } as const,
    full: { xs: 12 } as const,
  },
} as const;
